Vue.directive('matrixtooltip', {

  unbind (el) {
    $(el).tooltip('dispose');
  },

  /* update(el, binding)
    {
    }, */

  bind (el, binding) {
    if (window.matchMedia('(min-width: 768px)').matches) {
      setTimeout(() => {
        $(el).tooltip({
          sanitize: false,
          html: true,
          template: '<div class="tooltip matrix" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
          title: () => {
            return $(el).find('.tooltipContent').html();
          }
        });
      }, 1);
    }
  }
});
